/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".inventario__input-cantidad[_ngcontent-%COMP%]{min-width:80px;width:80px;max-width:100px;text-align:right}"];
export { styles as styles };
